import { jsx as d } from "react/jsx-runtime";
import { Y as m, F as p } from "./TabGroup-B4jOGf3W.js";
import "react";
import "immutable";
import "fast-levenshtein";
import "fuzzy";
import "fast-deep-equal";
import "./references-BRMYEcTr.js";
const f = "_Sandwich_sqsd9_6", h = "_fill_sqsd9_14", i = {
  Sandwich: f,
  fill: h
};
function q({
  inline: r,
  zIndex: o = 0,
  children: s,
  innerRef: l,
  style: t,
  className: e,
  position: n,
  childrenFill: a = !1,
  ...c
}) {
  return /* @__PURE__ */ d(
    "div",
    {
      style: {
        display: r ? "inline-block" : "block",
        zIndex: o,
        position: n ?? "relative",
        ...t
      },
      className: p(
        {
          [i.Sandwich]: !0,
          [i.fill]: a
        },
        e
      ),
      ref: l,
      ...c,
      children: m(s)
    }
  );
}
export {
  q as S
};
//# sourceMappingURL=Sandwich-eowxQOgu.js.map
